import React from "react";

export type BetaFeatureSet = Set<string>;

export interface AppContextValue {
  readonly betaFeatures: BetaFeatureSet;
  readonly currentUrl: string;
}

export const AppContext = React.createContext<AppContextValue>({
  betaFeatures: new Set(),
  currentUrl: "",
});
